import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const tokenInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<any> => {
  const authService = inject(AuthService);

  return from(authService.getValidIdToken()).pipe(
    switchMap((idToken) => {
      if (!idToken) {
        console.warn('tokenInterceptor - No se encontró un token vigente. Solicitando sin token.');
        return next(req);
      }

      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${idToken}`,
        },
      });

      return next(clonedRequest);
    })
  );
};
